import React, { useEffect, useState, useRef } from "react";
import "./index.css";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import playBtnImg from "../../../assets/images/marketplace/bnrPlay.png";
import Container from "../../../Components/General/Container";
import { imagePaths } from "../../../constants";

function HeroCareers() {
  const reference = useRef(null);
  const videoRef = useRef(null);
  const handleClick = () => {
    // alert("hey");

    if (reference && reference.current) {
      reference.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const handleHover = () => {
    videoRef.current?.play().catch(() => {
      /* Autoplay policy or a decode error — the hexagon stays visible. */
    });
  };

  const handleHoverOut = () => {
    if (!videoRef.current) return;
    videoRef.current.pause();
    videoRef.current.currentTime = 0;
  };

  const handleVideoEnded = () => {
    if (!videoRef.current) return;
    videoRef.current.currentTime = 0;
    handleHover();
  };

  useEffect(() => {
    const aosElements = document.querySelectorAll(".aosAnim");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("ltr");
            // entry.target.classList.remove("ltr-out");
          } else {
            // entry.target.classList.add("ltr-out");
            // entry.target.classList.remove("ltr");
          }
        });
      },
      {
        threshold: 0.3,
        // rootMargin: "-10px",
      }
    );

    aosElements.forEach((el) => {
      observer.observe(el);
    });

    // Clean up the observer on component unmount
    return () => {
      aosElements.forEach((el) => {
        observer.unobserve(el);
      });
    };
  }, []);

  return (
    <>
      <div className="mainBanner innerBanner marketbnr animated-section section">
        <div className="overflowSection">
          <Container>
            <div className="row bannerContent aosAnim">
              <div className="col-lg-7 leftBannerCont">
                <div className="bannerLeft">
                  <h2 className="titleText">
                    <span className="skyText">You belong</span> where <br />
                    bold ideas live.
                  </h2>
                  <p>
                    We're reshaping metal manufacturing and procurement - with
                    creativity, guts, and good people. Come build with us.
                  </p>
                  <div className="newDiv">#NowPurchaseCareers</div>

                  <a
                    href="#jobOpening"
                    onClick={handleClick}
                    className="npButton"
                    id="Careers_Section1_Landing_SeeJobOpenings"
                  >
                    See Job Openings
                  </a>
                </div>
              </div>
              <div className="col-lg-5 rightBannerImg">
                <div className="bannerRight">
                  <div
                    className="bannerPoly bannerPoly1"
                    onMouseEnter={handleHover}
                    onMouseLeave={handleHoverOut}
                  >
                    <img
                      loading="lazy"
                      src="https://images.nowpurchase.com/landing/20260522071137_Group 889446 (1).png"
                      alt=""
                      className="img-fluid"
                    />
                    <video
                      className="video"
                      muted
                      loop
                      playsInline
                      preload="none"
                      ref={videoRef}
                      onEnded={handleVideoEnded}
                      id="hoverVideo"
                    >
                      <source
                        src={imagePaths.CareerSectionVideo}
                        type="video/mp4"
                      />
                    </video>
                    <a
                      href="https://www.youtube.com/embed/mboNL2lIaEs"
                      className="bnrPlay"
                      data-fancybox=""
                    >
                      <img loading="lazy" src={playBtnImg} alt="" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </Container>
        </div>
      </div>
    </>
  );
}

export default HeroCareers;
